import { AST } from '@handlebars/parser';
import { isPathExpression } from 'modules/handlebars/domain/expression/utils';
import { isNull } from 'utils/tsHelpers';

export const getPathFromMustacheStatement = (
  mustacheStatement: AST.MustacheStatement | null,
): AST.PathExpression | null => {
  return !isNull(mustacheStatement) && isPathExpression(mustacheStatement.path)
    ? mustacheStatement.path
    : null;
};
